// The real experience is the static Key Secure landing page at /key-secure.html.
// The redirect actually fires from src/index.js BEFORE this component mounts,
// so this component is essentially never rendered. Kept as a no-op fallback.
function App() {
  return null;
}

export default App;
